import * as BaseApi from "./Base.api";

export const saveLogInfo = async (params: any) => {
    console.log("Log.Api.api:saveLogInfo");

    const url = `/log/www`;

    return await BaseApi.post(url, params);
};
